import { Component, Input, OnInit, computed, effect, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthService } from '../../services/auth.service';
import { getOfferFeatureFlagActions } from '../../store/actions/feature-flag.action';
import {
  selectOfferFeatureFlags,
  selectOfferFeatureFlagsProcessed,
  selectOfferIsDebtConsolidationEnabled,
} from '../../store/selectors/feature-flag.selector';
import { customerAttributesActions } from 'src/app/feature-modules/customer-attributes/store/customer-attributes.actions';
import { loadAccounts } from 'src/app/feature-modules/accounts/store/accounts.action';
import { selectAccountsLoaded } from 'src/app/feature-modules/accounts/store/accounts.selector';
import { selectCustomerAttributesLoaded } from 'src/app/feature-modules/customer-attributes/store/customer-attributes.selector';
import { loadOfferOffers } from '../../feature-modules/offers/store/actions/offers.actions';
import { selectOfferOffersIsLoaded } from '../../feature-modules/offers/store/selectors/offers.selectors';
import { DebtConsolidationService } from '../../services/debt-consolidation.service';

@Component({
  selector: 'app-offers-layout',
  templateUrl: './offers-layout.component.html',
  styleUrls: ['./offers-layout.component.scss'],
  standalone: false,
})
export class OffersLayoutComponent implements OnInit {
  @Input() currentUrl: string;
  idToken: string;

  private readonly accountsLoaded = this.store.selectSignal(selectAccountsLoaded);
  private readonly customerAttributesLoaded = this.store.selectSignal(
    selectCustomerAttributesLoaded
  );
  private readonly featureFlagsProcessed = this.store.selectSignal(
    selectOfferFeatureFlagsProcessed
  );
  private readonly offersLoaded = this.store.selectSignal(
    selectOfferOffersIsLoaded
  );
  private readonly featureFlags = this.store.selectSignal(
    selectOfferFeatureFlags
  );
  private readonly debtConsolidationEnabled = this.store.selectSignal(
    selectOfferIsDebtConsolidationEnabled
  );

  private readonly hasDispatchedOffers = signal(false);
  private readonly hasRequestedDebtConsolidation = signal(false);

  isLoaded = computed(
    () =>
      this.accountsLoaded() === true &&
      this.customerAttributesLoaded() === true &&
      this.featureFlagsProcessed() === true &&
      this.offersLoaded() === true &&
      this.debtConsolidationService.isLoaded() === true
  );

  constructor(
    private readonly store: Store,
    private readonly authService: AuthService,
    private readonly debtConsolidationService: DebtConsolidationService
  ) {
    effect(() => {
      const flags = this.featureFlags();
      if (!flags) return;

      if (!this.hasDispatchedOffers()) {
        this.hasDispatchedOffers.set(true);
        // due to some backend syncing issue, we need to wait for feature flags before calling offers
        this.store.dispatch(loadOfferOffers({ source: 'offers' }));
      }

      const enabled = this.debtConsolidationEnabled();
      if (enabled && !this.hasRequestedDebtConsolidation()) {
        this.hasRequestedDebtConsolidation.set(true);
        this.debtConsolidationService.requestDebtConsolidation();
      }
    });
  }

  async ngOnInit() {
    const { cid, idToken } = await this.authService.handleCurrentSessionRetrieval();
    this.idToken = idToken;

    this.store.dispatch(getOfferFeatureFlagActions.start({ request: 'offers' }));
    this.store.dispatch(customerAttributesActions.start({ request: 'offers' }));
    this.store.dispatch(loadAccounts());
  }
}
